import {
    formatReportCurrency,
    formatReportDateTime,
    formatReportPercent,
} from "@/utility/fclReportHelpers";

const cell = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    return String(value);
};

export const EXPORT_SALESPERSON_BOOKING_COLUMNS = [
    { key: "bookingNo", label: "BOOKING NO.", render: (row) => cell(row.bookingNo) },
    { key: "coordinator", label: "COORDINATOR", render: (row) => cell(row.coordinator) },
    { key: "salesPerson", label: "SALES PERSON", render: (row) => cell(row.salesPerson) },
    { key: "customer", label: "CUSTOMER", render: (row) => cell(row.customer) },
    { key: "contDetails", label: "CONT. DETAILS", render: (row) => cell(row.contDetails) },
    {
        key: "bkgDate",
        label: "BOOKING DATE",
        render: (row) => formatReportDateTime(row.bkgDate),
    },
    { key: "contactPerson", label: "CONTACT PERSON", render: (row) => cell(row.contactPerson) },
    {
        key: "pol",
        label: "POL / ETS",
        render: (row) => formatReportDateTime(row.pol ?? row.ets),
    },
    {
        key: "pod",
        label: "POD / ETA",
        render: (row) => formatReportDateTime(row.pod ?? row.eta),
    },
    {
        key: "buy",
        label: "BUY",
        render: (row) => (row.buy == null ? "-" : formatReportCurrency(row.buy)),
    },
    {
        key: "sell",
        label: "SELL",
        render: (row) => (row.sell == null ? "-" : formatReportCurrency(row.sell)),
    },
    {
        key: "profit",
        label: "PROFIT",
        render: (row) => (row.profit == null ? "-" : formatReportCurrency(row.profit)),
    },
    {
        key: "profitMargin",
        label: "PROFIT MARGIN",
        render: (row) => formatReportPercent(row.profitMargin),
    },
];

export const EXPORT_SALESPERSON_TEUS_COLUMNS = [
    {
        key: "salesPersonName",
        label: "SALES PERSON",
        render: (row) => cell(row.salesPersonName ?? row.SalesPersonName ?? "(Unassigned)"),
    },
    {
        key: "teus",
        label: "TEUS",
        render: (row) => (
            <span className="font-semibold text-emerald-700 dark:text-emerald-400">
                {Number(row.teus ?? row.Teus ?? 0).toFixed(2)}
            </span>
        ),
        exportValue: (row) => Number(row.teus ?? row.Teus ?? 0).toFixed(2),
    },
];

export const EXPORT_SALESPERSON_CONTACT_COLUMNS = [
    {
        key: "contactPersonName",
        label: "CONTACT PERSON",
        render: (row) => cell(row.contactPersonName ?? row.ContactPersonName ?? "(Unassigned)"),
    },
    {
        key: "noOfBooking",
        label: "NO. OF BOOKINGS",
        render: (row) => cell(row.noOfBooking ?? row.NoOfBooking),
    },
];

export { EXPORT_CONTAINER_TEUS_COLUMNS as EXPORT_SALESPERSON_CONTAINER_TEUS_COLUMNS } from "./exportBookingReportColumns";
